import { TMCTableModule } from '@sdbn/appclient';
import { MaterialModule, ServiceResponseModule } from '@sdbn/appclient';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WeighTransportDialogComponent } from './component/weigh-transport-dialog.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { ApplicationClientCommonModule } from '@sdbn/appclient';
import { TransportInfoPanelModule } from '@sdbn/appclient';
import { CommonTranslationModule } from '@sdbn/common';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    MatInputModule,
    ReactiveFormsModule,
    TransportInfoPanelModule,
    TMCTableModule,
    ApplicationClientCommonModule,
    ServiceResponseModule,
    CommonTranslationModule
  ],
  declarations: [WeighTransportDialogComponent]
})
export class TransportWeighingModule { }
